(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/rows-view.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/rows-view.js');
"use strict";

const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  useBetslipContext = _svs$components$tipse.useBetslipContext,
  Betslip = _svs$components$tipse.Betslip;
const Rows = _ref => {
  let isExtraSmall = _ref.isExtraSmall,
    numberOfRows = _ref.numberOfRows;
  if (isExtraSmall) {
    return React.createElement(React.Fragment, null, React.createElement("span", null, numberOfRows), React.createElement("span", null, " st"));
  }
  return React.createElement("span", null, React.createElement("span", null, numberOfRows), React.createElement("span", null, " st"));
};
const RowsView = _ref2 => {
  let label = _ref2.label,
    numberOfRows = _ref2.numberOfRows,
    numRows = _ref2.numRows,
    children = _ref2.children;
  const _useBetslipContext = useBetslipContext(),
    isExtraSmall = _useBetslipContext.isExtraSmall;
  const ariaLabel = "".concat(numRows || numberOfRows, " rader");
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "pg_tipsen_betslip_system"
  }, children), React.createElement(Betslip.RowsDisplay, {
    ariaLabel: ariaLabel,
    label: label
  }, React.createElement(Rows, {
    isExtraSmall: isExtraSmall,
    numberOfRows: numberOfRows
  })));
};
Betslip.RowsView = RowsView;

 })(window);